export const AnalyzeConstants = {
    REQUEST_ORIENTATION_DATA: 'REQUEST_ORIENTATION_DATA',
    RECEIVE_ORIENTATION_DATA: 'RECEIVE_ORIENTATION_DATA',
    ORIENTATION_DATA_ERROR: 'ORIENTATION_DATA_ERROR',


    REQUEST_ANALYZE_DATA: 'REQUEST_ANALYZE_DATA',
    RECEIVE_ANALYZE_DATA: 'RECEIVE_ANALYZE_DATA',
    ANALYZE_DATA_ERROR: 'ANALYZE_DATA_ERROR',
    
    SINGLE_VALIDATOR: 'SINGLE_VALIDATOR',
    SINGLE_VALIDATOR_FALSE: 'SINGLE_VALIDATOR_FALSE',

    RELOAD_TRUE:'RELOAD_TRUE',
    RELOAD_FALSE:'RELOAD_FALSE',

    REQUEST_PA_ANA_TEAM_LIST:"REQUEST_PA_ANA_TEAM_LIST",
    RECEIVE_PA_ANA_TEAM_LIST: "RECEIVE_PA_ANA_TEAM_LIST",
    ERROR_PA_ANA_TEAM_LIST: "ERROR_PA_ANA_TEAM_LIST",

    REQUEST_LnD_DATA: 'REQUEST_LnD_DATA',
    RECEIVE_LnD_DATA: 'RECEIVE_LnD_DATA',
    ERROR_LnD_DATA: 'ERROR_LnD_DATA',

    REQUEST_COLLOBORATION_DATA: 'REQUEST_COLLOBORATION_DATA',
    RECEIVE_COLLOBORATION_DATA: 'RECEIVE_COLLOBORATION_DATA',
    ERRO_COLLOBORATION_DATA: 'ERRO_COLLOBORATION_DATA',

    REQUEST_ATTRITION_PREDICTOR: 'REQUEST_ATTRITION_PREDICTOR',
    RECEIVE_ATTRITION_PREDICTOR: 'RECEIVE_ATTRITION_PREDICTOR',
    ERROR_ATTRITION_PREDICTOR: 'ERROR_ATTRITION_PREDICTOR',

    //List of team members of active batch
    REQUEST_USER_LIST:'REQUEST_USER_LIST',
    RECEIVE_USER_LIST: 'RECEIVE_USER_LIST',
    ERROR_USER_LIST: 'ERROR_USER_LIST',

    REQUEST_TEAM_FITMENT_DATA: 'REQUEST_TEAM_FITMENT_DATA',
    RECEIVE_TEAM_FITMENT_DATA: 'RECEIVE_TEAM_FITMENT_DATA',
    ERROR_TEAM_FITMENT_DATA: 'ERROR_TEAM_FITMENT_DATA',

    //role fitment
    REQUEST_ROLE_FITMENT_DATA: 'REQUEST_ROLE_FITMENT_DATA',
    RECEIVE_ROLE_FITMENT_DATA: 'RECEIVE_ROLE_FITMENT_DATA',
    ERROR_ROLE_FITMENT_DATA: 'ERROR_ROLE_FITMENT_DATA',

    REQUEST_FITMENTS_DATA: 'REQUEST_FITMENTS_DATA',
    RECEIVE_FITMENTS_DATA: 'RECEIVE_FITMENTS_DATA',
    ERROR_FITMENTS_DATA: 'ERROR_FITMENTS_DATA',

    REQUEST_HOLDERS_DATA: 'REQUEST_HOLDERS_DATA',
    RECEIVE_HOLDERS_DATA: 'RECEIVE_HOLDERS_DATA',
    ERROR_HOLDERS_DATA: 'ERROR_HOLDERS_DATA',

    //competency list
    REQUEST_COMPETENCY_LIST: 'REQUEST_COMPETENCY_LIST',
    RECEIVE_COMPETENCY_LIST: 'RECEIVE_COMPETENCY_LIST',
    ERROR_COMPETENCY_LIST: 'ERROR_COMPETENCY_LIST',

    //competency
    REQUEST_COMPETENCY: 'REQUEST_COMPETENCY',
    RECEIVE_COMPETENCY: 'RECEIVE_COMPETENCY',
    ERROR_COMPETENCY: 'ERROR_COMPETENCY',

    //Header Permission
    REQUEST_HEADER_PERMISSSION: 'REQUEST_HEADER_PERMISSSION',
    RECEIVE_HEADER_PERMISSSION: 'RECEIVE_HEADER_PERMISSSION',
    ERROR_HEADER_PERMISSSION: 'ERROR_HEADER_PERMISSSION'

}


// WEBPACK FOOTER //
// ./src/_constants/Analyze/analyze.constants.js